module.exports = __webpack_public_path__ + "img/1.b560c0d7.png";